<template>
  <div class="test" @mouseup="mouseUp">
      <div class="buttons">
          <el-button 
            :type="activeSide.name===side.name ? 'primary' : ''" 
            @click="changeSide(side)" 
            v-for="(side, index) of sides" 
            :key="index">
                {{side.name}}
            </el-button>
            <el-button :type="activeSide.name===perspective.name ? 'primary' : ''" @click="changeSide(perspective)">perspective</el-button>
      </div>
      <div class="card-container" >
        <div ref="card" class="card" :style="{ transform: transformStyle, transitionDuration: transformTime+'s'}">
            <div 
                @mousedown="mouseDown"
                @mousemove="mouseMove"
                @mouseup="mouseUp"
                :class="['side', `${side.name}-side`]" 
                v-for="(side, index) of sides" 
                :key="index">
                    {{side.name}}
            </div>
        </div>
      </div>
  </div>
</template>

<script> 
export default {
    data() {
        return {
            mouseDownStat: false,
            mouseUpStat:false,
            startX:0,
            endX:0,
            startY:0,
            endY:0,
            cardTransformZ: 1,
            transformTime: 0.8,
            perspective: {name:'perspective', rotate:{x:-45, y:35}},
            activeSide: {},
            sides:[
                {
                    name: 'front',
                    rotate: {
                        y:0,
                        x:0
                    }
                },
                    {
                    name: 'left',
                    rotate: {
                        y:90,
                        x:0
                    }
                },
                {
                    name: 'right',
                    rotate: {
                        y:-90,
                        x:0

                    }
                },
                {
                    name: 'back',
                    rotate: {
                        y:180,
                        x:0
                    }
                },
                {
                    name: 'up',
                    rotate: {
                        y:0,
                        x:-90
                    }
                },
                {
                    name: 'down',
                    rotate: {
                        y:0,
                        x:90
                    }
                },
            ]
            }

    },
    computed:{
        transformStyle(){
            return `rotateX(${this.activeSide.rotate.x}deg) rotateY(${this.activeSide.rotate.y}deg) scale3d(${this.cardTransformZ}, ${this.cardTransformZ}, ${this.cardTransformZ})`
        }
    },  
    methods: {
        changeSide(v){
            if(this.activeSide.name !== v.name){
                this.activeSide = JSON.parse(JSON.stringify(v))
                this.cardTransformZ=0.5
                setTimeout(()=>{
                    this.cardTransformZ=1
                },(this.transformTime*1000)/2)
            }
        },
        mouseDown(e){
            this.mouseDownStat = true
        },
        mouseMove(e){
            if(this.mouseDownStat && e.target.classList[0]==='side'){
                if(!this.startX){
                    return this.startX = e.clientX
                }else{
                    this.startX-e.clientX>0 ? this.activeSide.rotate.y-- : this.activeSide.rotate.y++
                    this.startY-e.clientY>0 ? this.activeSide.rotate.x++ : this.activeSide.rotate.x--
                    this.startX = e.clientX
                    this.startY = e.clientY
                }
            }
        },
        mouseUp(e){
            this.mouseDownStat=false
        }
    },
    beforeMount() {
        this.activeSide = JSON.parse(JSON.stringify(this.perspective))
    },
}
</script>

<style lang="scss">
    .test{
        display: grid;
        grid-template-columns: 1fr 5fr;
        height: 100%;
        justify-items: center;
        align-items: center;
        .buttons{
            justify-items: center;
            display: grid;
            grid-template-columns: 1fr;
            row-gap: 20px;
        }
        .el-button{
            width: 100%;
            margin: 0 !important;
        }
        .el-button::first-letter{
            text-transform: uppercase;
        }
        .card-container{
            perspective: 500px;
        }
        .card{
            transition-property: all;
            height: 400px;
            width: 200px;
            transform-style: preserve-3d;
            display: flex;
            justify-content: center;
            align-items: center;
            transform: scale(2);
        }
        .side{
            user-select: none;
            cursor: pointer;
            transition-duration: 0.3s;
            transition-property: all;
            position: absolute;
            width: inherit;
            height: inherit;
            border: 3px solid$basic-white;
            display: flex;
            justify-content: center;
            align-items: center;
            color: $basic-white;
            &:hover{
                filter: brightness(0.8);
            }
        }
        .front-side{
            transform: translateZ(100px) ;
            background-color: $brand-clr-1;
            border: 1px solid $brand-clr-1;
        }
        .back-side{
            transform: translateZ(-100px) rotateY(120deg);
            background-color: $danger-clr;
            border: 1px solid $danger-clr;
        }
        .left-side{
            transform:  translateX(-100px) rotateY(-90deg);
            background-color: $success-clr;
            border: 1px solid $success-clr;
        }
        .right-side{
            transform:  translateX(100px) rotateY(90deg);
            background-color: $warning-clr;
            border: 1px solid $warning-clr;
        }
        .down-side{
            height: 200px;
            transform:  translateY(200px) rotateX(-90deg);
            background-color: lightblue;
            border: 1px solid lightblue;
        }
        .up-side{
            height: 200px;
            transform:  translateY(-200px) rotateX(90deg);
            background-color: olive;
            border: 1px solid olive;
        }
    }
    @keyframes resize{
        to{
            transform: scale(1);
        }
        50%{
            transform: scale(0.5);
        }
        100%{
             transform: scale(1);
        }
    }
</style>